import { render, staticRenderFns } from "./GoodsSettingCustomRegionStyle.vue?vue&type=template&id=3959b842&scoped=true&"
import script from "./GoodsSettingCustomRegionStyle.vue?vue&type=script&lang=js&"
export * from "./GoodsSettingCustomRegionStyle.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSettingCustomRegionStyle.vue?vue&type=style&index=0&id=3959b842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3959b842",
  null
  
)

export default component.exports